import { callApiWithToken } from './base';
import config from '../../config';

export const fetchSelfVerificationTypes = async (token: string) =>
  callApiWithToken(`${config.urls.selfVerificationTypes}`, token, 'GET');
